// Resilience Multimedia Studios · Digital Artist Roster
// 24 digital-band acts baked in the ElevenLabs music pipeline.
// Every album opens with a self-titled introducer and closes with a
// long-form farewell (Coffin nail candidate #D-002 pattern).
//
// Audio serves at `/samples/musical-collection/<slug>.mp3` on the same origin.

export const ARTISTS = [
  {
    id: 1,
    slug: "flecking-viener",
    heroImage: "/artists/portraits/flecking-viener.png",
    name: "Flecking Viener",
    tagline: "The chameleon — one voice, every genre.",
    lane: "Male indie · broad-range solo",
    reference: "range-showcase indie · grunge → folk → pop → soul",
    accent: "#e2c05a",
    trackCount: 16,
    heroTrack: {
      slug: "flecking_viener_v15_heyya",
      title: "Hey Ya (Flecking Viener v15)",
    },
    tracks: [
      { slug: "flecking_viener_v2_tighter", title: "Tighter" },
      { slug: "flecking_viener_v6_nickelback", title: "Post-Grunge Stadium" },
      { slug: "flecking_viener_v8_algreen", title: "Soul Crossover" },
      { slug: "flecking_viener_v15_heyya", title: "Hey Ya (dance-pop)" },
    ],
        lore: "A chameleon of the studio's private roster — one voice that borrows every genre it steps into, then leaves without a name attached. The point is the flex, not the flag.",
    voiceRecipe: "Male tenor-baritone hybrid, wet vocal tail on the ballads, dry midrange on the belts, no vibrato until the third chorus, breath audible on the bridge.",
    palette: "Off-white cream + oxblood-red + ink-black. Poster serif over hand-cut paper. Studio-photograph vibe with one editorial blur.",
        lore: "Two men, one whistle, one microphone. The whole rehearsal room ran on Sunday coffee and a promise that the funk would still be there in the morning.",
    voiceRecipe: "Twin male leads trading bars — one lead is silk-tenor, the other is grit-baritone, both wet enough to catch a saxophone tail. Whistled hook every 32 bars.",
    palette: "Magenta neon + cyan under-glow + wet asphalt black. Chrome duo-tone poster face. Vaporwave dusk lighting.",
        lore: "Old-soul singer-songwriter for the room with wood floors, one lit candle, and a listener who owes their own life a slow evening.",
    voiceRecipe: "Warm baritone, cracked timbre on the high notes, no autotune. Falsetto reserved for the last chorus only. Sits back on the beat by a hair.",
    palette: "Sepia + amber-honey + soot-black. Grain-heavy analog. Single-candle warm rim-light.",
        lore: "Torch-pop out of a London back-alley in the rain. She stopped writing love songs the year her lover stopped writing back.",
    voiceRecipe: "Female mezzo — smoky lower octave, precise mid, no belt until the outro. Whisper-close mic technique with room bleed for the strings.",
    palette: "Sodium-lamp amber over petrol-blue midnight. Wet stone reflection. Trench-coat charcoal.",
        lore: "Atmospheric prog for the long ride at dusk. Every song is the same math problem written a different way; each answer is another mile.",
    voiceRecipe: "Male tenor, layered doubles at fifths, delay pad on every syllable, choir wash on the second half of each chorus.",
    palette: "Desert dusk gradient — cadmium orange over indigo. Silhouettes at magic hour. Painterly cinema.",
        lore: "Hard-blues-rock from the 1970s heavy tradition. If it doesn't sound like it was cut in a garage with the doors open, they burn it and cut it again.",
    voiceRecipe: "Male baritone-belt, dry tape compression on the lead, room ambience on the guitars, cowbell-clean drum kit that never drifts loud.",
    palette: "Copper-orange + iron-black + spark-yellow. Forge glow. Warm 35mm film stock.",
        lore: "Polished R&B-pop-funk with cinematic string arrangements. The song is a suit; the strings are the lining they only show you if you buy it.",
    voiceRecipe: "Female alto — clear, no vibrato until the tag-out, wet reverb bloom on every third phrase, string ensemble doubles the melody at the octave in the bridge.",
    palette: "Gold-leaf + porcelain ivory + black-silk. Editorial fashion palette. Warm rim-light.",
        lore: "Minor-key funk-rock-pop provocateur. The Purple lineage. Every arrangement earns its dissonance by the fourth bar or gets cut.",
    voiceRecipe: "Male tenor with falsetto flip, aggressive stage-mic presence, wide chorus effect on the belt, one guitar always answering the vocal line.",
    palette: "Deep violet + black-silk + one shock-of-white accent. Stage-light bleed. Wet reflection floor.",
        lore: "Chopper-flow storyteller. Multi-lane MC who spent more hours on the subway platform than in the studio. It shows and it should.",
    voiceRecipe: "Male mid-baritone rap, dense syllable counts per bar, live-recorded takes with no punch-ins, room ambience left in.",
    palette: "Concrete grey + one sodium-amber accent + cold blue. Gritty urban night. Under-lit subway platform.",
        lore: "Surf-punk / ska-punk / reggae-punk crossover from the beach town. Their manager owns the ice-cream truck.",
    voiceRecipe: "Male tenor lead with backing gang-vocals on choruses, upstroke guitar, dub tail on the outros, no autotune, one skank at 92 bpm forever.",
    palette: "Ocean teal + warm sand ochre + sun-bleached white. Palm frond shadows. High-noon sunlight.",
        lore: "Celtic-world-mystic ensemble in the Loreena McKennitt tradition. Half the record was recorded outside; you can hear the wind and it stayed in.",
    voiceRecipe: "Female soprano lead over uilleann pipes, harp, low whistle. Nyckelharpa on the bridges. Nothing electric.",
    palette: "Moss green + mist grey + candle-gold accents. Painterly forest cinema.",
        lore: "Late-1980s Nordic pop-rock crossover, male-female duo. The synth carries the melody; the voice carries the wound.",
    voiceRecipe: "Male baritone + female alto trade choruses; gated-snare reverb on the drums; DX7-style pad through the verses.",
    palette: "Cold cobalt + hot pink accent + steel grey. Late-80s cinematic. Neon on rainy asphalt.",
        lore: "Mixed-gender soft-rock trio in the warm 1977-1980 California lane. They drove out to the desert to record and never quite came all the way back.",
    voiceRecipe: "Two-part male-female harmony leads, close-miked warm vocals, Rhodes electric piano through a tape-slap delay, no click track on the ballads.",
    palette: "Coral pink + Fleetwood-brown wood + California sunset gold. 1977 station-wagon warm palette.",
        lore: "Theatrical operatic-rock — huge falsetto over opera-choir arena-rock. If the venue holds fewer than 3,000 seats, they don't take the booking.",
    voiceRecipe: "Male tenor with sustained falsetto climax, layered choir on the tag-outs, kick-drum four-on-the-floor for the whole third act.",
    palette: "Crimson curtain + gold-leaf + spotlight white. Opera-house palette. Rich painterly cinema.",
        lore: "Mid-1960s British-pop-rock male co-lead duo. Every album cover is the two of them looking at a different thing on the horizon.",
    voiceRecipe: "Two male leads in close harmony (thirds), jangly rhythm guitar with plectrum bounce audible, brass punches on the choruses, real live drum room.",
    palette: "Silver-blue + slate + a single scarlet accent. 1960s British seaside cinema.",
        lore: "Modern art-rock, glitchy and layered clean-electric beds. The band records at 3 a.m. because that's when the room hums quietest.",
    voiceRecipe: "Male tenor lead with vocoder doubles at fifths, clean-electric guitar loops through a shifting delay, no drums until the bridge.",
    palette: "Cool grey-blue + one amber-warm accent + analog TV-noise white. Painterly cinema.",
        lore: "Industrial electronic-rock — dynamic-range showcase. Every song opens quieter than the last and closes louder than the last opened.",
    voiceRecipe: "Male tenor lead with wet distortion on choruses only, industrial percussion loops, heavy detune pad on the bridges.",
    palette: "Ember-orange sparks + iron-grey + strobe-white. Industrial cinema.",
        lore: "Thrash-metal titan with aggressive baritone-shout vocals. Their sound-check is louder than most bands' shows.",
    voiceRecipe: "Male baritone shout with growl tails; drop-D guitars; double-bass drum patterns; gang-vocal shouts on the choruses.",
    palette: "Volcanic orange + iron black + white lightning accents. Heavy-metal album cinema.",
        lore: "Outlaw-country / Americana storyteller. Every song is a highway that leads somewhere the singer already left.",
    voiceRecipe: "Male baritone lead, telecaster twang with slap-back delay, walking-bass upright, brush drums, harmonica on the bridges.",
    palette: "Warm gold + oxblood + charcoal. Prairie sundown palette.",
        lore: "Neo-soul / torch-soul with cinematic string arrangements. She sings whole sentences that most singers would break into two lines.",
    voiceRecipe: "Female alto — smoky lower, precise mid, no belt until the outro. Legato phrasing; string quartet doubling the melody an octave down.",
    palette: "Deep black-lake + ember-orange + moon-white accent. Painterly cinema.",
        lore: "Male-led roots reggae in the one-drop tradition. Protest lyric spine, dub tail, message that outlives the tape.",
    voiceRecipe: "Male tenor lead, one-drop drums (kick and snare on the 3 only), skank guitar chops on the up-beat, wet delay tails on the outros.",
    palette: "Green + gold + red on ink-black. Roots-reggae album cinema.",
        lore: "Twin-vocoder digital duo — French house / electronic-funk. Everything sequenced live, no laptops on stage, they built the rig themselves.",
    voiceRecipe: "Twin vocoder-processed vocals answering each other, funk bass, LinnDrum kick pattern, filtered-house synth pads.",
    palette: "Neon blue + chrome silver + magenta gradient accent. Digital-punk cinema.",
        lore: "Stadium alt-rock — melodic verse into full-throated belt chorus. Written for the moment before the fireworks.",
    voiceRecipe: "Male tenor lead, wide-open chorus doubles, arena reverb on the snare, walls of stack-amp guitar on the last chorus.",
    palette: "Stadium confetti gold + arena red + spotlight white. Wide cinematic god-rays.",
        lore: "New-wave / art-punk / afrobeat-adjacent — moving-picture rhythm section. Every song has one riff that changes clothes six times.",
    voiceRecipe: "Male tenor with talk-sung verses, afrobeat guitar upstrokes, syncopated bass, hi-hat off-beat, gang vocals on the last chorus.",
    palette: "Monochrome grey + one shock-of-red accent. Origami paper cinema.",
        lore: "K-pop trio · dance-pop with bilingual Korean-English choruses. Trained together for six years before the first single dropped, on purpose.",
    voiceRecipe: "Three female sopranos in stacked harmony, bilingual lyric flip on every chorus, dance-pop production with a sub-drop before the last chorus.",
    palette: "Ethereal cool-blue + one warm amber ray + pearl-white accent. K-pop cinema.",
        lore: "Jam-band ensemble — violin, saxophone, acoustic guitar, upright bass, drums. Every setlist is different; they've never played the same set twice.",
    voiceRecipe: "Male tenor lead with looser phrasing, live-tracked full-band takes, no punch-ins, extended instrumental jams between choruses.",
    palette: "Warm amber + moss green + wood-brown. Jam-band summer festival cinema.",
        lore: "Experimental trip-hop, masked-collective performance art. Nobody knows how many members are in the band; the number changes with the song.",
    voiceRecipe: "Distorted whisper-vocals, chopped and screwed samples, live upright bass, one drum machine that lags a hair behind on purpose.",
    palette: "Deep black + bone-white + one blood-red accent. Occult-modern cinema.",
        lore: "The album-closer slot. Human-vocal-tape covers cleared under mechanical license. When the roster wants to send a signal, this is the tape.",
    voiceRecipe: "Whoever the song calls for — a rotating vocalist per track, no house sound imposed on the cover, honor the original arrangement.",
    palette: "Warm library palette — tape-reel brown + parchment cream + ink-black.",
        lore: "2000s pop-punk quartet · mall-rock catchy singalong lane. Their drummer is fifteen; their bassist is forty-three. Nobody talks about it.",
    voiceRecipe: "Male tenor lead with backing gang-vocals on choruses, palm-muted power-chord verses, four-on-the-floor kick, bright cymbals.",
    palette: "Hot pink + orange + skate-park graffiti green. Vaporwave sunset cinema.",
        lore: "Pop diva — theatrical, dance-pop meets ballad. She wrote her first hook when she was eleven and hasn't stopped.",
    voiceRecipe: "Female mezzo-soprano, precise belt on the choruses, layered stacked harmonies on the pre-chorus, one whistle-note per record.",
    palette: "Silver sequin + warm gold spotlight + mirror-tile reflections. Dance-floor cinema.",
        lore: "Alternative pop diva with strings and belt. The songs feel small when you stream them and huge when they land in a room.",
    voiceRecipe: "Female alto with soprano flip on the tag-outs, wet reverb on every third phrase, string ensemble doubling the melody in the bridge.",
    palette: "Deep purple + gold-leaf + iris-violet accent. Painterly floral cinema.",
        lore: "Bro-country trio — Nashville lane with a hard edge. Two guitars, one truck, one dog, four states in seven days.",
    voiceRecipe: "Male tenor lead with three-part harmony on the choruses, telecaster with slap-back, walking upright bass, brush-and-stick drums.",
    palette: "Bourbon amber + neon Nashville red + dust-road brown. Country-lane sundown cinema.",
        lore: "Country-blues-rock quartet — long-form American roots. Every song is at least six minutes because the story isn't finished at four.",
    voiceRecipe: "Male baritone lead with layered call-and-response backing, dobro slide guitar, upright bass, tambourine-and-brushes drums.",
    palette: "Golden-hour cottonwood + oxblood + wood-brown. Country-blues cinema.",
  },
  {
    id: 2,
    slug: "petal-pistol",
    name: "Petal & Pistol",
    tagline: "Two men, one whistle, and a wardrobe you can hear.",
    lane: "Male duo · viral funk-pop crossover",
    reference: "OutKast · Nas-adjacent brass-sample crossover · Mambo No. 5 revival",
    accent: "#ff5a00",
    trackCount: 10,
    heroImage: "/artists/portraits/petal-pistol.png",
    heroVideo: "/artists/petalpistol/petalpistol_kling_5s.mp4",
    heroTrack: {
      slug: "petalpistol_v1_petal_pistol_anthem",
      title: "Petal & Pistol (self-titled)",
    },
    tracks: [
      { slug: "petalpistol_v1_petal_pistol_anthem", title: "Petal & Pistol" },
      { slug: "petalpistol_v5_mambo_number_two", title: "Mambo Number Two" },
      { slug: "petalpistol_v6_blank_page_new_signature", title: "Blank Page, New Signature" },
      { slug: "petalpistol_v10_do_not_look_away", title: "Do Not Look Away" },
    ],
  },
  {
    id: 3,
    slug: "cyrus-bell",
    name: "Cyrus Bell",
    tagline: "The old-soul singer for a room with wood floors and one lit candle.",
    lane: "Male solo · old-soul singer-songwriter",
    reference: "Bill Withers · Al Green · early Marvin Gaye",
    accent: "#c88b3b",
    trackCount: 10,
    heroImage: "/artists/portraits/cyrus-bell.png",
    heroVideo: "/artists/cyrusbell/cyrusbell_kling_5s.mp4",
    heroTrack: {
      slug: "cyrus_bell_v1_long_highway",
      title: "Long Highway",
    },
    tracks: [
      { slug: "cyrus_bell_v1_long_highway", title: "Long Highway" },
      { slug: "cyrus_bell_v9_mommas_table", title: "Momma's Table" },
      { slug: "cyrus_bell_v10_bell_rings_slow", title: "Bell Rings Slow" },
    ],
  },
  {
    id: 4,
    slug: "vera-solis",
    name: "Vera Solis",
    tagline: "The London torch-singer walking home in the rain.",
    lane: "Female solo · 1960s cinematic torch-pop",
    reference: "Dusty Springfield · Shirley Bassey · Cilla Black",
    accent: "#c96a86",
    trackCount: 10,
    heroImage: "/artists/portraits/vera-solis.png",
    heroVideo: "/artists/verasolis/verasolis_kling_5s.mp4",
    heroTrack: {
      slug: "vera_solis_v1_vera_solis",
      title: "Vera Solis (self-titled)",
    },
    tracks: [
      { slug: "vera_solis_v1_vera_solis", title: "Vera Solis" },
      { slug: "vera_solis_v9_hands_of_the_many", title: "Hands Of The Many" },
      { slug: "vera_solis_v10_long_live_the_hope", title: "Long Live The Hope" },
    ],
  },
  {
    id: 5,
    slug: "long-division",
    heroImage: "/artists/portraits/long-division.png",
    name: "Long Division",
    tagline: "Slow-burn atmospheric prog for the long ride at dusk.",
    lane: "Atmospheric-prog · warm 1970s analog-tape long-form",
    reference: "Pink Floyd · warm Hammond-and-Mellotron soundscape",
    accent: "#3f6b7a",
    trackCount: 10,
    heroTrack: {
      slug: "long_division_v1_the_long_division",
      title: "The Long Division",
    },
    tracks: [
      { slug: "long_division_v1_the_long_division", title: "The Long Division" },
      { slug: "long_division_v2_money_god", title: "Money God" },
      { slug: "long_division_v10_the_long_way_home", title: "The Long Way Home" },
    ],
  },
  {
    id: 6,
    slug: "copper-anvil",
    heroImage: "/artists/portraits/copper-anvil.png",
    name: "Copper Anvil",
    tagline: "Thunder in the barn and blood on the drum-head.",
    lane: "Hard-blues-rock · warm 1970s heavy-blues",
    reference: "Led Zeppelin · warm Iron-Butterfly-adjacent psych-blues",
    accent: "#b25a2a",
    trackCount: 10,
    heroTrack: {
      slug: "copper_anvil_v1_copper_anvil",
      title: "Copper Anvil (self-titled)",
    },
    tracks: [
      { slug: "copper_anvil_v1_copper_anvil", title: "Copper Anvil" },
      { slug: "copper_anvil_v3_valkyrie_rider", title: "Valkyrie Rider" },
      { slug: "copper_anvil_v10_long_live_the_riff", title: "Long Live The Riff" },
    ],
  },
  {
    id: 7,
    slug: "ellison-gold",
    heroImage: "/artists/portraits/ellison-gold.png",
    name: "Ellison Gold",
    tagline: "Polished-to-a-mirror pop-funk with a falsetto that catches the light.",
    lane: "Male solo · polished R&B-pop-funk with cinematic strings",
    reference: "Michael Jackson · Quincy Jones production",
    accent: "#e2b74a",
    trackCount: 10,
    heroTrack: {
      slug: "ellison_gold_v1_gold_fever",
      title: "Gold Fever",
    },
    tracks: [
      { slug: "ellison_gold_v1_gold_fever", title: "Gold Fever" },
      { slug: "ellison_gold_v8_velvet_curtain", title: "Velvet Curtain" },
      { slug: "ellison_gold_v10_lantern_for_the_lost", title: "Lantern For The Lost" },
    ],
  },
  {
    id: 8,
    slug: "marquis-violet",
    name: "Marquis Violet",
    tagline: "The purple provocateur — sex, funk, and a scream in the falsetto.",
    lane: "Male solo · funk-rock-pop provocateur · minor-key",
    reference: "Prince · minor-key funk-rock crossover",
    accent: "#7c4bb8",
    trackCount: 10,
    heroImage: "/artists/portraits/marquis-violet.png",
    heroVideo: "/artists/marquisviolet/marquisviolet_kling_5s.mp4",
    heroTrack: {
      slug: "marquis_violet_v1_marquis_violet",
      title: "Marquis Violet (self-titled)",
    },
    tracks: [
      { slug: "marquis_violet_v1_marquis_violet", title: "Marquis Violet" },
      { slug: "marquis_violet_v9_velvet_rebellion", title: "Velvet Rebellion" },
      { slug: "marquis_violet_v10_purple_curtain_call", title: "Purple Curtain Call" },
    ],
  },
  {
    id: 9,
    slug: "verb-sinclair",
    heroImage: "/artists/portraits/verb-sinclair.png",
    name: "Verb Sinclair",
    tagline: "The chopper-flow storyteller who can rap eight lanes at once.",
    lane: "Male solo · rap · multi-lane storytelling MC",
    reference: "Eminem · Tech N9ne · underground-conscious hip-hop",
    accent: "#e04a6b",
    trackCount: 10,
    heroTrack: {
      slug: "verb_sinclair_v9_empire_diary",
      title: "Empire Diary",
    },
    tracks: [
      { slug: "verb_sinclair_v3_overcoat_swing", title: "Overcoat Swing" },
      { slug: "verb_sinclair_v9_empire_diary", title: "Empire Diary" },
      { slug: "verb_sinclair_v10_verb_the_verb", title: "Verb The Verb" },
    ],
  },
  {
    id: 10,
    slug: "palmwood",
    heroImage: "/artists/portraits/palmwood.png",
    name: "Palmwood",
    tagline: "Salt in the amp and sand in the drum-head.",
    lane: "Surf-punk / ska-punk / reggae-punk crossover",
    reference: "Sublime · Slightly Stoopid · Long Beach Dub Allstars",
    accent: "#4aa877",
    trackCount: 10,
    heroTrack: {
      slug: "palmwood_v1_palmwood",
      title: "Palmwood (self-titled)",
    },
    tracks: [
      { slug: "palmwood_v1_palmwood", title: "Palmwood" },
      { slug: "palmwood_v5_skate_church", title: "Skate Church" },
      { slug: "palmwood_v10_long_boardwalk", title: "Long Boardwalk" },
    ],
  },
  {
    id: 11,
    slug: "bough-and-bell",
    heroImage: "/artists/portraits/bough-and-bell.png",
    name: "Bough & Bell",
    tagline: "Mummers dance-forward · viral-designed Celtic-world-mystic.",
    lane: "Mixed digital ensemble · Celtic-world-mystic",
    reference: "Loreena McKennitt · Enya · Massive Attack refraction",
    accent: "#8ba368",
    trackCount: 8,
    heroTrack: {
      slug: "mummers_v2_the_mummers_come",
      title: "The Mummers Come",
    },
    tracks: [
      { slug: "mummers_v2_the_mummers_come", title: "The Mummers Come" },
      { slug: "mummers_v7_the_return", title: "The Return" },
    ],
  },
  {
    id: 12,
    slug: "neon-and-nightingale",
    name: "Neon & Nightingale",
    tagline: "Nostalgia bait engineered for a re-release generation.",
    lane: "Male-female duo · late-80s Swedish-pop-rock crossover",
    reference: "Roxette · gated-snare Swedish-pop-rock",
    accent: "#d15a9a",
    trackCount: 10,
    heroImage: "/artists/portraits/neon-and-nightingale.png",
    heroVideo: "/artists/neon_nightingale/neon_nightingale_kling_5s.mp4",
    heroTrack: {
      slug: "neon_nightingale_v1_neon_nightingale",
      title: "Neon & Nightingale (self-titled)",
    },
    tracks: [
      { slug: "neon_nightingale_v1_neon_nightingale", title: "Neon & Nightingale" },
      { slug: "neon_nightingale_v5_highway_2am", title: "Highway 2 A.M." },
      { slug: "neon_nightingale_v10_long_goodbye_airport", title: "Long Goodbye Airport" },
    ],
  },
  {
    id: 13,
    slug: "cassiopeia-motel",
    heroImage: "/artists/portraits/cassiopeia-motel.png",
    name: "Cassiopeia Motel",
    tagline: "Three drifters, one motel, one starlight sign.",
    lane: "Mixed-gender soft-rock trio · warm 1977-1980 California",
    reference: "Fleetwood Mac (Rumours era)",
    accent: "#b8956e",
    trackCount: 10,
    heroTrack: {
      slug: "cassiopeia_motel_v1_cassiopeia_motel",
      title: "Cassiopeia Motel (self-titled)",
    },
    tracks: [
      { slug: "cassiopeia_motel_v1_cassiopeia_motel", title: "Cassiopeia Motel" },
      { slug: "cassiopeia_motel_v6_slate_highway", title: "Slate Highway" },
      { slug: "cassiopeia_motel_v10_nightbird_highway", title: "Nightbird Highway" },
    ],
  },
  {
    id: 14,
    slug: "regalia",
    name: "Regalia",
    tagline: "Cape, crown, and a wailing guitar over a 30-voice opera choir.",
    lane: "Theatrical operatic-rock · huge falsetto + opera-choir",
    reference: "Queen · theatrical arena-rock with gospel-piano",
    accent: "#d9a54a",
    trackCount: 10,
    heroImage: "/artists/portraits/regalia.png",
    heroVideo: "/artists/regalia/regalia_kling_5s.mp4",
    heroTrack: {
      slug: "regalia_v1_regalia",
      title: "Regalia (self-titled)",
    },
    tracks: [
      { slug: "regalia_v1_regalia", title: "Regalia" },
      { slug: "regalia_v8_pressure_piano", title: "Pressure Piano" },
      { slug: "regalia_v10_the_long_ovation", title: "The Long Ovation" },
    ],
  },
  {
    id: 15,
    slug: "the-silver-comb",
    heroImage: "/artists/portraits/the-silver-comb.png",
    name: "The Silver Comb",
    tagline: "Two-part close-harmony British pop-rock for the Sunday-afternoon world.",
    lane: "Male co-lead duo · mid-1960s British pop-rock",
    reference: "The Beatles (Rubber Soul → Abbey Road)",
    accent: "#a0a0a8",
    trackCount: 10,
    heroTrack: {
      slug: "silver_comb_v1_silver_comb",
      title: "The Silver Comb (self-titled)",
    },
    tracks: [
      { slug: "silver_comb_v1_silver_comb", title: "The Silver Comb" },
      { slug: "silver_comb_v7_turkish_coffee", title: "Turkish Coffee" },
      { slug: "silver_comb_v10_long_silver_path", title: "The Long Silver Path" },
    ],
  },
  {
    id: 16,
    slug: "static-owl",
    heroImage: "/artists/portraits/static-owl.png",
    name: "Static Owl",
    tagline: "Anxiety-cathedral art-rock for the long-ago wire.",
    lane: "Modern art-rock · glitchy + layered clean-electric beds",
    reference: "Radiohead (OK Computer / In Rainbows / Kid A era)",
    accent: "#5a7d9a",
    trackCount: 10,
    heroTrack: {
      slug: "static_owl_v1_static_owl",
      title: "Static Owl (self-titled)",
    },
    tracks: [
      { slug: "static_owl_v1_static_owl", title: "Static Owl" },
      { slug: "static_owl_v5_karma_circumstance", title: "Karma Circumstance (7/8)" },
      { slug: "static_owl_v10_the_blue_silence", title: "The Blue Silence" },
    ],
  },
  {
    id: 17,
    slug: "ashwire",
    heroImage: "/artists/portraits/ashwire.png",
    name: "Ashwire",
    tagline: "Whispered-to-screamed industrial-rock.",
    lane: "Industrial electronic-rock · dynamic-range showcase",
    reference: "Nine Inch Nails (Downward Spiral / The Fragile era)",
    accent: "#7a2a2a",
    trackCount: 10,
    heroTrack: {
      slug: "ashwire_v1_ashwire",
      title: "Ashwire (self-titled)",
    },
    tracks: [
      { slug: "ashwire_v1_ashwire", title: "Ashwire" },
      { slug: "ashwire_v4_wont_heal_wont_break", title: "Won't Heal, Won't Break" },
      { slug: "ashwire_v10_every_day_is_exit_room", title: "Every Day Is Exit Room" },
    ],
  },
  {
    id: 18,
    slug: "ironmaw",
    heroImage: "/artists/portraits/ironmaw.png",
    name: "Ironmaw",
    tagline: "Palm-muted thrash titan · double-bass kick and harmonized twin leads.",
    lane: "Thrash-metal titan · aggressive baritone-shout",
    reference: "Metallica (Master of Puppets / And Justice For All era)",
    accent: "#9a9aa5",
    trackCount: 10,
    heroTrack: {
      slug: "ironmaw_v1_ironmaw",
      title: "Ironmaw (self-titled)",
    },
    tracks: [
      { slug: "ironmaw_v1_ironmaw", title: "Ironmaw" },
      { slug: "ironmaw_v4_fade_to_ember", title: "Fade To Ember" },
      { slug: "ironmaw_v10_the_wolfsbane_waltz", title: "The Wolfsbane Waltz (3/4)" },
    ],
  },
  {
    id: 19,
    slug: "blackrail",
    heroImage: "/artists/portraits/blackrail.png",
    name: "Blackrail",
    tagline: "Deep-baritone outlaw-country storyteller for a long-ago Sunday.",
    lane: "Outlaw-country / Americana storyteller",
    reference: "Johnny Cash (American Recordings era + Man In Black)",
    accent: "#4a4a52",
    trackCount: 10,
    heroTrack: {
      slug: "blackrail_v1_blackrail",
      title: "Blackrail (self-titled)",
    },
    tracks: [
      { slug: "blackrail_v1_blackrail", title: "Blackrail" },
      { slug: "blackrail_v7_whiskey_and_a_bible", title: "Whiskey And A Bible" },
      { slug: "blackrail_v10_long_black_coat", title: "Long Black Coat" },
    ],
  },
  {
    id: 20,
    slug: "ember-halloran",
    name: "Ember Halloran",
    tagline: "Warm smoky torch-soul contralto for a room with wood floors.",
    lane: "Female solo · neo-soul / torch-soul with cinematic strings",
    reference: "Adele · Amy Winehouse · Motown-adjacent live drums",
    accent: "#d4562e",
    trackCount: 10,
    heroImage: "/artists/portraits/ember-halloran.png",
    heroVideo: "/artists/emberhalloran/emberhalloran_kling_5s.mp4",
    heroTrack: {
      slug: "ember_halloran_v1_ember_halloran",
      title: "Ember Halloran (self-titled)",
    },
    tracks: [
      { slug: "ember_halloran_v1_ember_halloran", title: "Ember Halloran" },
      { slug: "ember_halloran_v4_someone_just_like_me", title: "Someone Just Like Me" },
      { slug: "ember_halloran_v10_long_love_song", title: "Long Love Song" },
    ],
  },
  {
    id: 21,
    slug: "ironroot",
    heroImage: "/artists/portraits/ironroot.png",
    name: "Ironroot",
    tagline: "Dread-cadence roots-reggae protest music for a long night.",
    lane: "Male-led roots reggae · one-drop tradition · protest",
    reference: "Bob Marley & The Wailers (Exodus / Uprising / Kaya era)",
    accent: "#3a7a55",
    trackCount: 10,
    heroTrack: {
      slug: "ironroot_v1_ironroot",
      title: "Ironroot (self-titled)",
    },
    tracks: [
      { slug: "ironroot_v1_ironroot", title: "Ironroot" },
      { slug: "ironroot_v6_get_up_rise_up", title: "Get Up, Rise Up" },
      { slug: "ironroot_v10_one_iron_heart", title: "One Iron Heart" },
    ],
  },
  {
    id: 22,
    slug: "vector-twins",
    heroImage: "/artists/portraits/vector-twins.png",
    name: "Vector Twins",
    tagline: "Twin robot voices over French-house electronic-funk.",
    lane: "Twin-vocoder digital duo · French house / electronic-funk",
    reference: "Daft Punk (Discovery / Random Access Memories era)",
    accent: "#d9c74a",
    trackCount: 10,
    heroTrack: {
      slug: "vector_twins_v1_vector_twins",
      title: "Vector Twins (self-titled)",
    },
    tracks: [
      { slug: "vector_twins_v1_vector_twins", title: "Vector Twins" },
      { slug: "vector_twins_v5_sharper_faster", title: "Sharper Faster Better Longer" },
      { slug: "vector_twins_v10_long_play_farewell", title: "Long Play Farewell" },
    ],
  },
  {
    id: 23,
    slug: "longhaul",
    name: "Longhaul",
    tagline: "Stadium alt-rock for the seven-hour drive and the eighty-thousand-person singalong.",
    lane: "Stadium alt-rock · melodic verse + full-throated belt chorus",
    reference: "Foo Fighters (Colour and the Shape / Wasting Light era)",
    accent: "#7a5a3a",
    trackCount: 10,
    heroImage: "/artists/portraits/longhaul.png",
    heroVideo: "/artists/longhaul/longhaul_kling_5s.mp4",
    heroTrack: {
      slug: "longhaul_v1_longhaul",
      title: "Longhaul (self-titled)",
    },
    tracks: [
      { slug: "longhaul_v1_longhaul", title: "Longhaul" },
      { slug: "longhaul_v3_best_left_of_you", title: "Best Left Of You" },
      { slug: "longhaul_v10_long_way_home_ovation", title: "Long Way Home Ovation" },
    ],
  },
  {
    id: 24,
    slug: "paper-currency",
    heroImage: "/artists/portraits/paper-currency.png",
    name: "Paper Currency",
    tagline: "Nervous new-wave art-punk with a horn-section chorus.",
    lane: "New-wave / art-punk / afrobeat-adjacent",
    reference: "Talking Heads (Remain In Light / Fear Of Music era)",
    accent: "#c9a53a",
    trackCount: 10,
    heroTrack: {
      slug: "paper_currency_v1_paper_currency",
      title: "Paper Currency (self-titled)",
    },
    tracks: [
      { slug: "paper_currency_v1_paper_currency", title: "Paper Currency" },
      { slug: "paper_currency_v4_burning_down_kitchen", title: "Burning Down The Kitchen" },
      { slug: "paper_currency_v10_long_silence_ovation", title: "The Long Silence Ovation" },
    ],
  },
  {
    id: 25,
    slug: "halflight",
    name: "HALFLIGHT · 반빛",
    tagline: "Three girls, three coasts of Korea, one debut night that fell apart — and the year that followed.",
    lane: "3-girl K-POP trio · dance-pop with bilingual Korean-English chorus",
    reference: "Modern K-POP · non-hero coming-of-age story arc · flagship trio",
    accent: "#ff5a9a",
    trackCount: 10,
    heroImage: "/artists/portraits/halflight.png",
    heroVideo: "/artists/halflight/halflight_kyra_kling_5s.mp4",
    heroVideoAlt: "HALFLIGHT · Kyra · Kling 3.0 · 5-second cinematic push-in",
    heroTrack: {
      slug: "halflight_v1_halflight",
      title: "Halflight (반빛)",
    },
    tracks: [
      { slug: "halflight_v1_halflight", title: "Halflight (반빛)" },
      { slug: "halflight_v2_ready_or_not", title: "Ready or Not" },
      { slug: "halflight_v3_never_mind", title: "Never Mind" },
      { slug: "halflight_v4_for_the_girls", title: "For The Girls" },
      { slug: "halflight_v5_coastal_fire", title: "Coastal Fire" },
      { slug: "halflight_v6_tangerine_ash", title: "Tangerine Ash" },
      { slug: "halflight_v7_concrete", title: "Concrete" },
      { slug: "halflight_v8_debut_night", title: "Debut Night" },
      { slug: "halflight_v9_busking_fire", title: "Busking Fire" },
      { slug: "halflight_v10_first_light", title: "First Light (첫 빛)" },
      { slug: "halflight_v11_tribute_trap_pop_fire", title: "How You Like That — Tribute", tag: "tribute · not ours · trap-K-pop tradition" },
    ],
    featured: true,
  },
  {
    id: 26,
    slug: "bridge-and-bourbon",
    heroImage: "/artists/portraits/bridge-and-bourbon.png",
    name: "Bridge & Bourbon",
    tagline: "The 5-piece jam ensemble for the summer amphitheater at dusk.",
    lane: "Jam-band ensemble · violin + saxophone + acoustic guitar + bass + drums",
    reference: "Dave Matthews Band lane · warm outdoor festival · virtuoso jam extensions",
    accent: "#c98a3a",
    trackCount: 10,
    tracks: [],
  },
  {
    id: 27,
    slug: "coyote-chapel",
    heroImage: "/artists/portraits/coyote-chapel.png",
    name: "Coyote Chapel",
    tagline: "Masked art-collective from a desert warehouse under red service lights.",
    lane: "Puscifer-lane experimental trip-hop · masked-collective performance art",
    reference: "Puscifer · Maynard-Keenan side-project sonic palette · ritual-warehouse staging",
    accent: "#b04a3a",
    trackCount: 10,
    tracks: [],
  },
  {
    id: 28,
    slug: "house-covers",
    heroImage: "/artists/portraits/house-covers.png",
    name: "House Covers (Lane C · reserved)",
    tagline: "Reserved slot for human-tape true covers — mechanical-licensed at release, tracked and added as each album's closer per band.",
    lane: "House covers · human-vocal tape · album-closer slot",
    reference: "One true cover per tribute band, recorded with session vocalists, mechanical license cleared at distribution.",
    accent: "#4b4b4b",
    trackCount: 0,
    tracks: [],
  },
  {
    id: 29,
    slug: "skatepark-saints",
    heroImage: "/artists/portraits/skatepark-saints.png",
    name: "Skatepark Saints",
    tagline: "The garage-quartet suburban pop-punk band with a mall parking lot chorus.",
    lane: "2000s pop-punk quartet · mall-rock catchy singalong",
    reference: "Good Charlotte · New Found Glory · All-American Rejects lane",
    accent: "#e83a4c",
    trackCount: 10,
    tracks: [],
  },
  {
    id: 30,
    slug: "belle-cordelia",
    heroImage: "/artists/portraits/belle-cordelia.png",
    name: "Belle Cordelia",
    tagline: "The crossover-pop diva who owns the country hook, the dance drop, and the world groove.",
    lane: "Female solo · crossover-pop diva (country-pop / dance-pop / world-pop hybrid)",
    reference: "Taylor Swift · Britney Spears · Shakira crossover lane",
    accent: "#e9a5c1",
    trackCount: 10,
    tracks: [],
  },
  {
    id: 31,
    slug: "empress-iris",
    heroImage: "/artists/portraits/empress-iris.png",
    name: "Empress Iris",
    tagline: "The fierce R&B empress with a stadium of dancers behind her.",
    lane: "Female solo · fierce R&B mega-diva empowerment",
    reference: "Beyonce lane · Sasha-Fierce staging · gold-and-onyx armor",
    accent: "#d4af3b",
    trackCount: 10,
    tracks: [],
  },
  {
    id: 32,
    slug: "bourbon-roads",
    heroImage: "/artists/portraits/bourbon-roads.png",
    name: "Bourbon Roads",
    tagline: "Three friends on a tailgate at golden hour, one holding a beat-up acoustic.",
    lane: "Bro-country / alt-country hybrid trio",
    reference: "Morgan Wallen · Luke Combs · Zach Bryan composite lane",
    accent: "#c99a4d",
    trackCount: 10,
    tracks: [],
  },
  {
    id: 33,
    slug: "cottonwood-fret",
    heroImage: "/artists/portraits/cottonwood-fret.png",
    name: "Cottonwood Fret",
    tagline: "Country-blues-rock roadhouse quartet with a Strat and a neon Pabst sign.",
    lane: "Country-blues-rock quartet",
    reference: "Kenny Wayne Shepherd Band lane · roadhouse-blues extended solos",
    accent: "#3a6480",
    trackCount: 10,
    tracks: [],
  },
  {
    id: 34,
    slug: "nordlys",
    heroImage: "/artists/portraits/nordlys.png",
    name: "Nordlys",
    tagline: "Norwegian princess-fairy-warrior with the voice of an angel and every living thing in mind.",
    lane: "Female solo · Nordic-folk-electronic warrior-hymn",
    reference: "Nordic-folk-electronic tradition · ethereal soprano head-voice · earth-and-peace warrior ballads",
    accent: "#a7c8d6",
    trackCount: 11,
    lore:
      "A twenty-four-year-old fairy-warrior stepping barefoot out of a fjord at dawn — silver circlet, moonstone at her forehead, ceremonial sword loose at her hip, red silk against white snow. Every song is a hymn to the small hands and the wildflower field. Voice of an angel. Every living thing in mind.",
    palette:
      "Moon-silver on midnight blue · aurora-green threads · red-on-white blood-in-snow accent · wildflower dust-gold rimlight · high-contrast graphic-novel color grading in the tradition of 300 and Sin City.",
    voiceRecipe:
      "Ethereal Nordic-folk soprano head-voice · wordless-chant choir · Hardanger fiddle + hammered dulcimer + frame-drums + seljefløyte + subtle electronic bloom under the choruses · modal-minor Dorian throughout · no auto-tune · no pop belt · no rock scream.",
    heroTrack: {
      slug: "nordlys_v1_nordlys",
      title: "Nordlys (self-titled)",
    },
    tracks: [
      { slug: "nordlys_v1_nordlys", title: "Nordlys", tag: "opener" },
      { slug: "nordlys_v2_warrior_at_dawn", title: "Warrior At Dawn", tag: "fairy-warrior hymn" },
      { slug: "nordlys_v3_every_living_thing", title: "Every Living Thing", tag: "earth hymn" },
      { slug: "nordlys_v4_speak_to_the_trees", title: "Speak To The Trees", tag: "forest communion" },
      { slug: "nordlys_v5_the_peace_you_buried", title: "The Peace You Buried", tag: "quiet-anger elegy" },
      { slug: "nordlys_v6_small_hands_great_fire", title: "Small Hands, Great Fire", tag: "children-light hymn" },
      { slug: "nordlys_v7_wolf_sister", title: "Wolf-Sister", tag: "myth-cycle" },
      { slug: "nordlys_v8_blood_on_the_snow", title: "Blood On The Snow", tag: "war-grief ballad" },
      { slug: "nordlys_v9_the_sun_way_home", title: "The Sun-Way Home", tag: "return hymn" },
      { slug: "nordlys_v10_long_goodbye_to_the_kings", title: "Long Goodbye To The Kings", tag: "album closer" },
      { slug: "nordlys_v11_the_seed", title: "The Seed (tribute)", tag: "T11 tribute · Aurora tradition" },
    ],
  },
  {
    id: 35,
    slug: "turndash",
    heroImage: "/artists/portraits/turndash.png",
    name: "Turndash",
    tagline: "Absurd-sincerity love-song artist · one song, sixteen ways · the comedy IS the sincerity.",
    lane: "Solo · acoustic-alt-rock singer-songwriter · one-song-mini-album",
    reference: "Warm tenor-baritone with natural grit · alt-rock-adjacent expressive delivery · one signature comedic-earnest love song rendered across every genre imaginable",
    accent: "#c07850",
    trackCount: 16,
    lore:
      "A 6-foot-1 hiker-build twenty-something with reddish-blonde spiky hair, a very short dark-blonde-red stubbly beard, blue eyes, and one of the most welcoming smiles ever caught on film. Sings one song. One. But he sings it sixteen ways — bossa, gospel, techno, disco, bluegrass, flamenco, trap, lo-fi, synthwave, reggae, rock, neo-soul, incubus-adjacent, pop, epic-orchestral, and a plain love-song reading. The joke is the sincerity. The heart is the joke.",
    palette:
      "Warm 1970s Kodak Portra film grain · burnt-amber + sun-bleached-denim + faded khaki + warm skin tones · magic-hour and porch-lantern golden warmth throughout the mini-album MV cycle.",
    voiceRecipe:
      "Warm tenor-baritone with natural grit — expressive alt-rock-adjacent melisma on the held notes, absurd-sincerity delivery locked in every take (no wink, no smirk in the vocal — the comedy IS the sincerity). Layered gang-backing vocals stacking behind him on the Turn-Dash chorus lift.",
    heroTrack: {
      slug: "for_turn_dash_love_song",
      title: "The Turn-Dash Song (love-song reading)",
    },
    tracks: [
      { slug: "for_turn_dash_love_song",      title: "Love-Song Reading",      tag: "the plain heart of it" },
      { slug: "for_turn_dash_rock",           title: "Rock Version",           tag: "distorted arena take" },
      { slug: "for_turn_dash_pop",            title: "Pop Version",            tag: "polished radio take" },
      { slug: "for_turn_dash_incubus",        title: "Alt-Rock Version",       tag: "Incubus-adjacent grain" },
      { slug: "for_turn_dash_techno",         title: "Techno Version",         tag: "four-on-the-floor absurd" },
      { slug: "for_turn_dash_disco",          title: "Disco Version",          tag: "1970s dance-floor" },
      { slug: "for_turn_dash_reggae",         title: "Reggae Version",         tag: "one-drop skank" },
      { slug: "for_turn_dash_neo_soul",       title: "Neo-Soul Version",       tag: "Rhodes + horns" },
      { slug: "for_turn_dash_trap",           title: "Trap Version",           tag: "808 sub" },
      { slug: "for_turn_dash_bossa",          title: "Bossa Nova Version",     tag: "nylon guitar + brush" },
      { slug: "for_turn_dash_gospel",         title: "Gospel Version",         tag: "cathedral choir lift" },
      { slug: "for_turn_dash_epic_orchestral",title: "Epic Orchestral Version",tag: "cinematic-fantasy scale" },
      { slug: "for_turn_dash_bluegrass",      title: "Bluegrass Version",      tag: "banjo + mandolin" },
      { slug: "for_turn_dash_synthwave",      title: "Synthwave Version",      tag: "1980s neon-cassette" },
      { slug: "for_turn_dash_flamenco",       title: "Flamenco Version",       tag: "cajón + rasgueado" },
      { slug: "for_turn_dash_lofi_hiphop",    title: "Lo-Fi Hip-Hop Version",  tag: "vinyl-crackle boom-bap" },
    ],
  },
  {
    id: 36,
    slug: "voltaire-march",
    heroImage: "/artists/portraits/voltaire-march.png",
    name: "Voltaire March",
    tagline: "Solo genre-bending theatrical alt-rock — ska-cabaret in one verse, symphonic-rock climax the next, desert-industrial trip-hop by the bridge.",
    lane: "Solo · genre-bending theatrical alt-rock",
    reference: "Ska-pop-cabaret bounce · operatic-symphonic-rock climaxes · industrial-electronic desert-rock trip-hop interludes · one album, twelve tonal costume changes",
    accent: "#8b1a2c",
    trackCount: 10,
    lore:
      "A 6-foot theatrical solo male in a tailored three-piece suit (oxblood lining, brass buttons, gold pocket-watch chain) who changes musical costume every 90 seconds. One verse is a Nutty-Boys-adjacent ska-cabaret bounce with a live horn section. The next is a cathedral-scale operatic-rock climax with layered choir. The bridge is a desert-hooded trip-hop sardonic close-mic. He is the argument that a solo artist can be an entire festival by himself.",
    palette:
      "Matte black + oxblood red + gold-leaf accent + a single flash of electric ultramarine on symphonic climaxes + Puscifer-adjacent sun-bleached ochre on desert interludes + 2-tone ska chessboard black-and-white on the Madness-adjacent bounce sequences.",
    voiceRecipe:
      "Warm theatrical mid-baritone with operatic tenor lifts and falsetto flourishes on the symphonic climaxes, dry sardonic spoken-sung delivery on the trip-hop interludes, playful shout-belt call-and-response on the ska-cabaret bounces. Layered 20+ voice cathedral choir on the operatic peaks. Occasional pitched-up character-voice backing on the industrial-electronic beats.",
    heroTrack: {
      slug: "voltaire_march_v1_voltaire_march",
      title: "Voltaire March (self-titled)",
    },
    tracks: [
      { slug: "voltaire_march_v1_voltaire_march",       title: "Voltaire March",         tag: "opener · ska-symphonic" },
      { slug: "voltaire_march_v2_two_tone_sermon",      title: "Two-Tone Sermon",        tag: "ska-cabaret full-bounce" },
      { slug: "voltaire_march_v3_cathedral_confession", title: "The Cathedral Confession", tag: "symphonic-rock epic" },
      { slug: "voltaire_march_v4_desert_interlude",     title: "Desert Interlude (One Man Radio)", tag: "industrial trip-hop" },
      { slug: "voltaire_march_v5_parade_of_one",        title: "The Parade Of One",      tag: "triumphant ska-symphonic" },
      { slug: "voltaire_march_v6_chessboard_blues",     title: "Chessboard Blues",       tag: "2-tone walking-bass" },
      { slug: "voltaire_march_v7_operatic_regicide",    title: "Operatic Regicide",      tag: "cathedral-climax" },
      { slug: "voltaire_march_v8_sun_bleached_ochre",   title: "Sun-Bleached Ochre",     tag: "desert-hooded trip-hop" },
      { slug: "voltaire_march_v9_whole_festival_alone", title: "The Whole Festival Alone", tag: "solo-as-festival" },
      { slug: "voltaire_march_v10_the_long_bow",        title: "The Long Bow",           tag: "album closer · long-goodbye" },
    ],
  },
  {
    id: 37,
    slug: "blueleaf-coyote",
    heroImage: "/artists/portraits/blueleaf-coyote.png",
    name: "Blueleaf Coyote",
    tagline: "Six-piece folk / bluegrass / jam-band ensemble — every track is an excuse for a solo pass and a three-part harmony chorus.",
    lane: "Ensemble jam-band · folk-bluegrass-jam tradition",
    reference: "Jam-band improv arcs · Southern-rock dual-lead guitar harmonies · 1970s jazz-fusion extended chord voicings · virtuoso acoustic-loop-solo tradition · bluegrass-breakdown ensemble discipline",
    accent: "#7ba05b",
    trackCount: 12,
    lore:
      "Six musicians who met at a music-college jam session and never stopped playing together — the primary voice a warm mid-baritone storyteller, a co-lead tenor with a wistful timbre, and four instrumentalists trading solo passes every bridge. Every track is a jam pretending to be a song, or a song pretending to be a jam — the distinction dissolves after the second chorus. Recorded live on the porch with no click track, every time.",
    palette:
      "Sun-through-cottonwood palette · warm ochre + kudzu green + porch-lantern amber + high-mountain river-blue · 1970s Kodachrome film grain · magic-hour outdoor light + candle-lit indoor jam interiors.",
    voiceRecipe:
      "Warm mid-baritone primary lead + higher wistful tenor co-lead trading songs · three-part male close-harmony chorus stack · warm live acoustic drum kit · warm walking upright bass · warm acoustic guitar 16ths · warm banjo + mandolin counter-lines · warm fiddle lead solos · warm Rhodes electric piano · warm Hammond organ swells · occasional pedal-steel and warm tenor saxophone · extended improv solo passage inside every bridge · warm 1970s analog-tape mastering.",
    heroTrack: {
      slug: "blueleaf_coyote_v1_blueleaf_coyote",
      title: "Blueleaf Coyote (self-titled)",
    },
    tracks: [
      { slug: "blueleaf_coyote_v1_blueleaf_coyote",        title: "Blueleaf Coyote",         tag: "opener · jam-band-Dead" },
      { slug: "blueleaf_coyote_v2_river_bend_reverie",     title: "River-Bend Reverie",      tag: "Southern-rock shuffle" },
      { slug: "blueleaf_coyote_v3_kudzu_and_kerosene",     title: "Kudzu And Kerosene",      tag: "bluegrass breakdown" },
      { slug: "blueleaf_coyote_v4_the_ferry_bell",         title: "The Ferry Bell",          tag: "folk ballad" },
      { slug: "blueleaf_coyote_v5_slow_fig_afternoon",     title: "Slow Fig Afternoon",      tag: "acoustic loop solo" },
      { slug: "blueleaf_coyote_v6_seven_hills_shuffle",    title: "Seven Hills Shuffle",     tag: "Southern-rock" },
      { slug: "blueleaf_coyote_v7_almanac_after_midnight", title: "Almanac After Midnight",  tag: "jazz-fusion jam" },
      { slug: "blueleaf_coyote_v8_cottonwood_creek",       title: "Cottonwood Creek",        tag: "jam-band groove" },
      { slug: "blueleaf_coyote_v9_porch_lantern_promise",  title: "Porch-Lantern Promise",   tag: "folk ballad" },
      { slug: "blueleaf_coyote_v10_long_road_homeward",    title: "Long Road Homeward",      tag: "album closer" },
      { slug: "blueleaf_coyote_v11_jam_dead_tribute",      title: "Long Strange Trip (tribute)", tag: "T11 jam-band-Dead tribute" },
      { slug: "blueleaf_coyote_v12_southern_rock_tribute", title: "Ramble Home (tribute)",   tag: "T12 Southern-rock tribute" },
    ],
  },
];
